// extracted by mini-css-extract-plugin
export default {"scc__vbs__container":"VbsSignup_scc__vbs__container__foU-s","scc__vbs__form":"VbsSignup_scc__vbs__form__3-QxK"};